import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
    selector: 'app-page-size-picker',
    templateUrl: './page-size-picker.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageSizePickerComponent {

    @Input() collectionSize: number = 10000; // default value must not be 0 else it resets to first page
    @Input() currentPageNumber: number = 0;
    @Input() public disabled = false;

    itemsPerPage!: number; // default value must not be 0 else it resets to first page

    public pageSizeOptions = [10, 25, 50, 100];

    get offset(): number {
        return this.itemsPerPage * (this.currentPageNumber - 1);
    }

    get limit(): number {
        return this.itemsPerPage;
    }

    constructor(private localStorageService: LocalStorageService) {
        this.itemsPerPage = localStorageService.itemsPerPage;
    }

    public changePagesize(newPageSize: number) {
        this.localStorageService.itemsPerPage = newPageSize;
        this.currentPageNumber = 1;
        this.itemsPerPage = newPageSize;
    }
}
